import React from 'react';
import { UsersIcon, TargetIcon, MapIcon } from 'lucide-react';
import { Section } from '../Section';
import { Figure } from '../Figure';
import { Pill } from '../ui/Pill';
import { images } from '../../data/caseStudy';
const frame = [{
  icon: UsersIcon,
  label: 'Who it was for',
  title: 'Analysts and traders',
  body: 'Consuming global gas and LNG market data daily, previously across two separate toolsets.'
}, {
  icon: TargetIcon,
  label: 'The job to be done',
  title: "Explore merged data sets in one place",
  body: "Data sets were still in the process of being built into GeoJSON files."
}, {
  icon: MapIcon,
  label: 'What I owned',
  title: 'Interactive map + wider UX',
  body: 'Dynamic layer controls with live results, alongside shoring up the surrounding experience.'
}];
export function Problem() {
  return <Section number="02" kicker="Problem framing" title="The problem, and who it was for" lede="I conducted contextual research with the team, analysts and traders to understand how they consumed market data, while evaluating the existing work to identify areas of friction and opportunities for improvement." tone="navy" data-id="element-110" data-mp="6wv16dule6wq">
      <div className="grid grid-cols-3 gap-5" data-id="element-111" data-mp="198266ncqtgd2">
        {frame.map(item => {
        const Icon = item.icon;
        return <div key={item.title} className="avoid-break rounded-2xl border border-white/10 bg-white/[0.04] p-7" data-id="element-112" data-mp="vcq9wbixvhu1">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-green/15" data-id="element-113" data-mp="1nzb55n2jce2v">
                <Icon className="h-4 w-4 text-green" aria-hidden="true" data-id="element-114" data-mp="1s0ek87cre631" />
              </span>
              <p className="mt-6 font-sans text-[11px] font-medium uppercase tracking-[0.18em] text-white/40" data-id="element-115" data-mp="1e99huxi0azp0">
                {item.label}
              </p>
              <h3 className="mt-3 font-display text-[20px] font-semibold leading-tight tracking-[-0.02em] text-white" data-id="element-116" data-mp="1j6rqsnw0xex0">
                {item.title}
              </h3>
              <p className="mt-3 font-sans text-[14px] leading-[1.7] text-white/55" data-id="element-117" data-mp="2bovmk1j1j3a1">{item.body}</p>
            </div>;
      })}
      </div>

      <div className="mt-12 flex flex-wrap gap-2" data-id="element-118" data-mp="2ljuj4igopuz1">
        <Pill variant="navy" data-id="element-119" data-mp="2gkzrcr0qow2s">Crude</Pill>
        <Pill variant="navy" data-id="element-120" data-mp="2gm2eqoyusgdy">Refined products</Pill>
        <Pill variant="navy" data-id="element-121" data-mp="2bm6e8zpd7735">NGL</Pill>
        <Pill variant="navy" data-id="element-122" data-mp="2bl52et0iygkd">Gas</Pill>
        <Pill variant="navy" data-id="element-123" data-mp="2bo985utn1kd5">LNG</Pill>
        <Pill variant="outline" data-id="element-124" data-mp="26o4v6erxv7ro">Green energy</Pill>
      </div>

      <div className="mt-12" data-id="element-125" data-mp="22lrmbhhwatqo">
        <Figure src={images.detailPanel} alt="A regional view of the map with a pipeline detail panel open, showing route, capacity, status and route geometry confidence." caption="Selecting a route opens a detail panel: route, capacity, status, geometry source and node-level confidence, data analysts previously had to look up elsewhere manually." label="Lumen — Infrastructure / route detail" tone="navy" data-id="element-126" data-mp="22lzzzblue32x" />
      </div>
    </Section>;
}